import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import routes from '@config/routes'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '100%',
    left: 0,
    width: '100%',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    padding: '16px 24px',
    borderRadius: '0 0 8px 8px'
  },
  menuItem: {
    cursor: 'pointer',
    padding: '8px 0',
    '&:hover': {
      color: '#7966eb'
    }
  }
}))

/**
 * NavbarSubMenu component
 * Displays a submenu in the desktop navigation bar
 */
const NavbarSubMenu = ({ items, onClose }) => {
  const classes = useStyles()

  if (!items || items.length === 0) {
    return null
  }

  return (
    <Box className={classes.root}>
      {items.map((item, index) => (
        <Typography
          key={`submenu-item-${index}`}
          variant="body2"
          className={classes.menuItem}
          onClick={() => {
            if (item.onClick) {
              item.onClick()
            }
            if (onClose) {
              onClose()
            }
          }}
        >
          {item.label}
        </Typography>
      ))}
    </Box>
  )
}

NavbarSubMenu.propTypes = {
  /** Array of submenu items with label and onClick properties */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func
    })
  ),
  /** Callback function when submenu is closed */
  onClose: PropTypes.func
}

NavbarSubMenu.defaultProps = {
  items: [],
  onClose: () => {}
}

/**
 * NavbarSubMenu configuration
 * This defines the submenu items for each collapsable section in the sidebar
 */
export default {
  costs: [
    {
      link: routes.costs.summary,
      display_name: 'summary',
      exactURL: null
    },
    {
      link: routes.costs.suppliers,
      display_name: 'suppliers',
      exactURL: null
    },
    {
      link: routes.costs.expenses,
      display_name: 'expenses',
      exactURL: null
    },
    {
      link: routes.costs.contracts,
      display_name: 'supplier_contracts',
      exactURL: null
    }
  ],
  invoices: [
    {
      link: routes.invoicing.summary,
      display_name: 'summary',
      exactURL: null
    },
    {
      link: routes.invoicing.planning.root,
      display_name: 'planning',
      exactURL: null
    },
    {
      link: routes.invoicing.invoices,
      display_name: 'invoices',
      exactURL: null
    },
    {
      link: routes.invoicing.followups,
      display_name: 'followups',
      exactURL: null
    },
    {
      link: routes.invoicing.payments,
      display_name: 'payments',
      exactURL: null
    },
    {
      link: routes.invoicing.tenants,
      display_name: 'tenants',
      exactURL: null
    },
    {
      link: routes.invoicing.exports,
      display_name: 'exports',
      exactURL: null
    }
  ],
  collaboration: [
    {
      link: routes.collaboration.blog,
      display_name: 'blog',
      exactURL: null
    },
    {
      link: routes.collaboration.tasks,
      display_name: 'tasks',
      exactURL: null
    },
    {
      link: routes.collaboration.notifications,
      display_name: 'notifications',
      exactURL: null
    },
    {
      link: routes.collaboration.calendar,
      display_name: 'calendar',
      exactURL: null
    }
  ],
  finances: [
    {
      link: routes.investors.root,
      display_name: 'investors',
      exactURL: null
    },
    {
      link: routes.internal.root,
      display_name: 'internal',
      exactURL: null
    }
  ]
}
